var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFellows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6249 10.2933C13.5672 10.2933 14.3311 9.52939 14.3311 8.58708C14.3311 7.64476 13.5672 6.88086 12.6249 6.88086C11.6826 6.88086 10.9187 7.64476 10.9187 8.58708C10.9187 9.52939 11.6826 10.2933 12.6249 10.2933Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7436 9.44075C18.6859 9.44075 19.4498 8.67686 19.4498 7.73454C19.4498 6.79222 18.6859 6.02832 17.7436 6.02832C16.8013 6.02832 16.0374 6.79222 16.0374 7.73454C16.0374 8.67686 16.8013 9.44075 17.7436 9.44075Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50627 9.44075C8.44858 9.44075 9.21248 8.67686 9.21248 7.73454C9.21248 6.79222 8.44858 6.02832 7.50627 6.02832C6.56395 6.02832 5.80005 6.79222 5.80005 7.73454C5.80005 8.67686 6.56395 9.44075 7.50627 9.44075Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 6.597C11.2923 6.597 12.0562 5.83311 12.0562 4.89079C12.0562 3.94847 11.2923 3.18457 10.35 3.18457C9.4077 3.18457 8.6438 3.94847 8.6438 4.89079C8.6438 5.83311 9.4077 6.597 10.35 6.597Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8999 6.597C15.8423 6.597 16.6062 5.83311 16.6062 4.89079C16.6062 3.94847 15.8423 3.18457 14.8999 3.18457C13.9576 3.18457 13.1937 3.94847 13.1937 4.89079C13.1937 5.83311 13.9576 6.597 14.8999 6.597Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21257 15.412V12.2839C9.21248 11.9414 9.28995 11.6033 9.43918 11.295C9.58841 10.9867 9.80551 10.7162 10.0742 10.5038C9.92024 10.2644 9.70854 10.0676 9.45859 9.93142C9.20864 9.79526 8.92846 9.72414 8.64383 9.72461H6.36888C5.91636 9.72461 5.48238 9.90437 5.1624 10.2244C4.84242 10.5443 4.66266 10.9783 4.66266 11.4308V13.912H4.66003V15.6773H5.59282C5.66073 15.6899 5.7301 15.6964 5.80014 15.6964H6.08451V19.9619H8.9282V15.6964H9.23817C9.22094 15.6026 9.21237 15.5074 9.21257 15.412Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0468 16.5604V20.8154H11.2031V16.5604H9.78782V15.5345C9.78346 15.4941 9.78125 15.4534 9.78125 15.4124V12.2843C9.78125 11.8318 9.96101 11.3978 10.281 11.0779C10.601 10.7579 11.035 10.5781 11.4875 10.5781H13.7624C14.2149 10.5781 14.6489 10.7579 14.9689 11.0779C15.2889 11.3978 15.4686 11.8318 15.4686 12.2843V15.4124C15.4686 15.4534 15.4664 15.4941 15.4621 15.5345V16.5604H14.0468Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5873 13.954V11.4308C20.5873 10.9783 20.4076 10.5443 20.0876 10.2244C19.7676 9.90437 19.3336 9.72461 18.8811 9.72461H16.6062C16.3215 9.72414 16.0414 9.79526 15.7914 9.93142C15.5415 10.0676 15.3298 10.2644 15.1758 10.5038C15.4445 10.7162 15.6616 10.9867 15.8108 11.295C15.96 11.6033 16.0375 11.9414 16.0374 12.2839V15.412C16.0376 15.5074 16.0291 15.6026 16.0118 15.6964H16.3218V19.9619H19.1655V15.7194H20.59V13.954H20.5873Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellows);
export default __webpack_public_path__ + "static/media/fellows.f0affaa8d5265c74e4d207a82a9adf55.svg";
export { ForwardRef as ReactComponent };